let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_COUNTRY": "Add Country",
    "LBL_VIEW_COUNTRY": "View Country",
    "LBL_COUNTRY_NAME": "Name",
    "LBL_ISD_CODE": "ISD Code",
    "LBL_STATUS": "Status",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
}

export default language;